
import Vue from "vue";
import Footer from "@/components/common/Footer.vue";
import Header from "@/components/About/Header.vue";
import JobCareer from "@/components/About/JobCareer.vue";
import MainServices from "@/components/About/MainServices.vue";
import ClientAndPartners from "@/components/About/ClientAndPartners.vue";
import MainMenu from "@/components/common/MainMenu.vue";

export default Vue.extend({
  name: "AboutUs",
  components: {
    MainMenu,
    //ClientAndPartners,
    MainServices,
    JobCareer,
    Footer,
    Header,
  },
  data() {
    return {
      displayMenu: false,
    };
  },
  mounted() {
    const currentUser = localStorage.getItem("currentUser");
    this.displayMenu = currentUser === null;
  },
});
